// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.MyCustomHits { width: 1000px; }*/

.App {
  text-align: left;
}
/* 
a.ais-ToggleRefinement-list
{
color: red;
} */

a.ais-Pagination-link {
  background-color: white;
  border: 1px solid #eee;
  color: #555;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
}

a.ais-Pagination-link:hover {
  color: grey;
}

.ais-Pagination-item--selected a.ais-Pagination-link {
  color: #fff;
  background-color: #5bc2a8;
  border-color: #5bc2a8;
}

.ais-SearchBox {
  margin: 1em 0;
}
.ais-Pagination {
  margin-top: 1em;
}

/* .ais-Hits-item { color: teal} */

/* li.ais-Hits-item{
width: 950px;
} */

/* .ais-ToggleRefinement
{
color: white;
} */

.ais-Hits-list {
  display: flex;
  flex-direction: column;
  justify-content: left;
}

.pagination {
  display: flex;
  justify-content: left;
}
/* 
.slider-teal
{
color:hotpink;
background-color: hotpink;
}

.left-panel
{
width: 200px;
} */

/* .filter-pink
{
color:white;
font-family: Times;
font-size: 15px;
background-color: pink;
border-radius: 5px;
} */

/* .hit-description { color: teal; font-size: 14px;} */

/* .hit {
color:teal;
font-family: Times;
font-size: 15px;
background-color: white;
border-radius: 5px;
} */

.flex-container {
  display: flex;
}

.flex-container-pagination {
  display: flex;
  flex-direction: column;
  width: 860px;
  @media (max-width: 600px) {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/discovery/App.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,gBAAgB;AAClB;AACA;;;;GAIG;;AAEH;EACE,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA,kCAAkC;;AAElC;;GAEG;;AAEH;;;GAGG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;;;;;;;;;;GAUG;;AAEH;;;;;;;GAOG;;AAEH,sDAAsD;;AAEtD;;;;;;GAMG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ;IACE,WAAW;EACb;AACF","sourcesContent":["/*.MyCustomHits { width: 1000px; }*/\n\n.App {\n  text-align: left;\n}\n/* \na.ais-ToggleRefinement-list\n{\ncolor: red;\n} */\n\na.ais-Pagination-link {\n  background-color: white;\n  border: 1px solid #eee;\n  color: #555;\n  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);\n}\n\na.ais-Pagination-link:hover {\n  color: grey;\n}\n\n.ais-Pagination-item--selected a.ais-Pagination-link {\n  color: #fff;\n  background-color: #5bc2a8;\n  border-color: #5bc2a8;\n}\n\n.ais-SearchBox {\n  margin: 1em 0;\n}\n.ais-Pagination {\n  margin-top: 1em;\n}\n\n/* .ais-Hits-item { color: teal} */\n\n/* li.ais-Hits-item{\nwidth: 950px;\n} */\n\n/* .ais-ToggleRefinement\n{\ncolor: white;\n} */\n\n.ais-Hits-list {\n  display: flex;\n  flex-direction: column;\n  justify-content: left;\n}\n\n.pagination {\n  display: flex;\n  justify-content: left;\n}\n/* \n.slider-teal\n{\ncolor:hotpink;\nbackground-color: hotpink;\n}\n\n.left-panel\n{\nwidth: 200px;\n} */\n\n/* .filter-pink\n{\ncolor:white;\nfont-family: Times;\nfont-size: 15px;\nbackground-color: pink;\nborder-radius: 5px;\n} */\n\n/* .hit-description { color: teal; font-size: 14px;} */\n\n/* .hit {\ncolor:teal;\nfont-family: Times;\nfont-size: 15px;\nbackground-color: white;\nborder-radius: 5px;\n} */\n\n.flex-container {\n  display: flex;\n}\n\n.flex-container-pagination {\n  display: flex;\n  flex-direction: column;\n  width: 860px;\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
